import i18next from 'i18next';

import {
  toggleQuantityInputHasError,
  updateQuantityInputErrorMessage,
  updateQuantityInputInConts,
} from 'actions/placeorder';
import { isSpotContract } from 'helpers/utils';
import {
  quantityInputHasErrorSelector,
  quantityInputValue,
} from 'selectors/placeOrderSelector';
import { selectedProductSelector } from 'selectors/tradeSelectors';

import { convertNumberOfContractsToSelectedCurrency } from '../../../formulae';

const resetErrors = () => (dispatch, getState) => {
  const state = getState();
  const quantityInputHasError = quantityInputHasErrorSelector(state);
  if (quantityInputHasError) {
    dispatch(toggleQuantityInputHasError(false));
    dispatch(updateQuantityInputErrorMessage(''));
  }
};

const handleError =
  (value, selectedDropdown, side, forceError = false) =>
  (dispatch, getState) => {
    const state = getState();
    const selectedProduct = selectedProductSelector(state);
    const qtyInput = quantityInputValue(state);

    if ((Number(value) > 0 || value === '' || value === null) && !forceError) {
      dispatch(resetErrors());
    } else if (qtyInput !== null || forceError) {
      const convertedValue = convertNumberOfContractsToSelectedCurrency(
        1,
        selectedProduct ?? {},
        selectedDropdown,
        side
      );

      let quantity = `${convertedValue} ${selectedDropdown}`;

      if (isSpotContract(selectedProduct?.contract_type)) {
        quantity = `${selectedProduct?.contract_value} ${selectedProduct?.contract_unit_currency}`;
      }

      if (Number(qtyInput) < Number(convertedValue) || Number(qtyInput) === 0) {
        dispatch(toggleQuantityInputHasError(true));
        dispatch(updateQuantityInputInConts(0));
        dispatch(
          updateQuantityInputErrorMessage(
            i18next.t('errors:placeOrder.orderSizeError', {
              quantity,
            })
          )
        );
      }
    }
  };

export { resetErrors };
export default handleError;
